import { NOTIFICATIONS } from 'config/api-routes';
import { setMessagesCountData, setNotificationsCountData } from 'store/actions/messages.action';
import { GET, PATCH } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

export default class NotificationService {
  async getNotifications(opts = {}) {
    const response = await GET(NOTIFICATIONS.LIST.GET(), opts);

    return formatResponse(response);
  }

  async readNotifications(opts = {}) {
    const response = await PATCH(NOTIFICATIONS.READ.PATCH(), { userId: 'system' }, opts);

    return formatResponse(response);
  }

  async getUnreadNotificationsCount(opts = {}) {
    const response = await GET(NOTIFICATIONS.COUNT.GET(), opts);

    return formatResponse(response);
  }

  async getAllUnreadNotifications(opts = {}) {
    const response = await GET(NOTIFICATIONS.ALL_COUNT.GET(), opts);

    return formatResponse(response);
  }

  async checkForNewNotifications(opts = {}) {
    const counts = await this.getAllUnreadNotifications(opts);

    setMessagesCountData(counts.user);
    setNotificationsCountData(counts.system);
  }
}
